export default __webpack_public_path__ + "static/media/Interactive.0d0f52ba.svg";